import Vue from 'vue'
import VueRouter from 'vue-router'

export default class {
	constructor() {
		Vue.use(VueRouter);

		this.router = new VueRouter({
			routes: [],
			mode: "history",
		});
	}
}
